import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout, Field, inputCls, primaryBtn } from "@/components/AuthLayout";
import { useAuth } from "@/context/AuthContext";
import { PasswordInput } from "@/components/PasswordInput";
import { GoogleButton } from "@/components/GoogleAuth";
import { errMsg, ROLE_HOME } from "@/lib/api";

export const SignupForm = ({ path, fields, testPrefix }) => {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({});
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await signIn(path, form);
      nav(ROLE_HOME[u.role]);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid={`${testPrefix}-form`}>
      {fields.map((f) => (
        <Field key={f.name} label={f.label}>
          <FieldInput
            password={f.type === "password"}
            {...(f.type === "password" ? { testId: `${testPrefix}-${f.name}-input` } : { "data-testid": `${testPrefix}-${f.name}-input`, type: f.type || "text" })}
            required={!f.optional}
            placeholder={f.placeholder}
            className={inputCls}
            value={form[f.name] || ""}
            onChange={(e) => setForm({ ...form, [f.name]: e.target.value })}
          />
        </Field>
      ))}
      {error && <p data-testid={`${testPrefix}-error`} className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
      <button data-testid={`${testPrefix}-submit-button`} disabled={busy} className={primaryBtn}>{busy ? "Creating account…" : "Create account"}</button>
    </form>
  );
};

const FieldInput = ({ password, ...props }) => (password ? <PasswordInput {...props} /> : <input {...props} />);

export const BASE_FIELDS = [
  { name: "name", label: "Full name" },
  { name: "phone", label: "Mobile number", type: "tel", placeholder: "+675 7xxx xxxx" },
  { name: "email", label: "Email", type: "email" },
  { name: "password", label: "Password (min 6 characters)", type: "password" },
];

export default function Register() {
  return (
    <AuthLayout
      title="Create your rider account"
      subtitle="Book Comfort Taxi rides across Port Moresby in seconds."
      side={{ title: "Upfront fares in Kina. Pay cash on arrival.", text: "Pick your pickup on the map, see the price, and a blue cab comes to you." }}
    >
      <GoogleButton testId="register-google-button" />
      <SignupForm path="/auth/register" fields={BASE_FIELDS} testPrefix="register" />
      <p className="mt-6 text-sm text-slate-500">Already have an account? <Link to="/login" data-testid="register-to-login-link" className="font-semibold text-blue-700">Sign in</Link></p>
    </AuthLayout>
  );
}
